import React, { useState, useEffect } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import classNames from "classnames";
import StorageService from '../../../../services/StorageService';
import { useService } from '../../../../base/hooks/useService';
import { KEY_USER } from "../../../../base/constants/storage";
import NotActivatedSamplesTab from "./NotActivatedSamplesTab";
import AllSamplesTab from "./AllSamplesTab";

const SampleTable = () => {
  /**
   * @type {StorageService}
   */
  const storage = useService(StorageService);

  const DEFAULT_OPTIMALLY_ME_ORG = 1;
  const { organisationId } = storage.get(KEY_USER, { organisationId: DEFAULT_OPTIMALLY_ME_ORG });
  const [activeTab, setActiveTab] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get('tab');
    return tab === 'notActivatedSamples' ? 1 : 0;
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tabName = activeTab === 0 ? 'allSamples' : 'notActivatedSamples';
    params.set('tab', tabName);
    window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);
  }, [activeTab]);

  const handleTabClick = (index) => {
    if (activeTab !== index) {
      setActiveTab(index);
      const tabName = index === 0 ? 'allSamples' : 'notActivatedSamples';
      window.history.replaceState({}, "", `${window.location.pathname}?tab=${tabName}`);
    }
  };

  return (
    <div>
      <Nav tabs className="nav-tabs-custom nav-justified mt-1">
        <NavItem>
          <NavLink
            className={classNames({ active: activeTab === 0 }, "cursor-pointer")}
            onClick={() => handleTabClick(0)}
          >
            All Samples
          </NavLink>
        </NavItem>
        {organisationId === 5 && (
          <NavItem>
            <NavLink
              className={classNames({ active: activeTab === 1 }, "cursor-pointer")}
              onClick={() => handleTabClick(1)}
            >
              Not activated samples received by lab
            </NavLink>
          </NavItem>
        )}
      </Nav>
      <div className="mt-4">
        {activeTab === 0 && <AllSamplesTab key="allSamples" />}
        {activeTab === 1 && organisationId === 5 && <NotActivatedSamplesTab key="notActivatedSamples" />}
      </div>
    </div>
  );
};

export default SampleTable;
